import { Navigate, Route, Routes as RouterDomRoutes } from 'react-router-dom'

import { NotFound } from '@/common/pages'
import { SystemRequirementsDetails } from '@/modules/requirements/pages/Details'

export function Routes(): JSX.Element {
  return (
    <RouterDomRoutes>
      <Route path="/:name" element={<SystemRequirementsDetails />} />
      <Route path="*" element={<Navigate replace to="/hub" />} />
      <Route path="/not-found" element={<NotFound />} />
    </RouterDomRoutes>
  )
}
